/* import __COLOCATED_TEMPLATE__ from './hitl-options.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
// @ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

type Option = 'on' | 'off';

const MIN_THRESHOLD = 10;

interface Signature {
  Args: {
    assignableAdmins: $TSFixMe;
    selectedOption: Option;
    setSelectedOption: (option: Option) => void;
    selectedThreshold: number;
    setSelectedThreshold: (threshold: number) => void;
    selectedAssigneeId: string | null;
    setAssigneeId: (id: string) => void;
    selectedTimeoutSeconds: number;
    setTimeoutSeconds: (seconds: number) => void;
    isInteractionDisabled: boolean;
    showVolumeHelper: boolean;
    estimatedConversationsPerDay: number;
    minTimeoutSeconds: number;
    maxTimeoutSeconds: number;
    predicateGroup?: $TSFixMe;
    onPredicateGroupChange?: (predicates: $TSFixMe) => void;
    attributeGroupList?: $TSFixMe[];
  };
}

export default class HitlOptions extends Component<Signature> {
  get isEnabled(): boolean {
    return this.args.selectedOption === 'on';
  }

  get normalizedPercent(): number {
    return (
      Math.round(((this.args.selectedThreshold - MIN_THRESHOLD) / (100 - MIN_THRESHOLD)) * 10000) /
      100
    );
  }

  get options() {
    return [
      {
        value: 'off' as const,
        translationKey: 'operator.fin.setup.setup-and-go-live.ask-a-teammate.radio-off.label',
        subtitleTranslationKey:
          'operator.fin.setup.setup-and-go-live.ask-a-teammate.radio-off.description',
      },
      {
        value: 'on' as const,
        translationKey: 'operator.fin.setup.setup-and-go-live.ask-a-teammate.radio-on.label',
        subtitleTranslationKey:
          'operator.fin.setup.setup-and-go-live.ask-a-teammate.radio-on.description',
      },
    ];
  }

  get thresholdSliderStyle(): string {
    let pct = this.normalizedPercent;
    return sanitizeHtml(
      `background: linear-gradient(to right, var(--neutral-fill) 0%, var(--neutral-fill) ${pct}%, var(--neutral-container-emphasis) ${pct}%, var(--neutral-container-emphasis) 100%)`,
    );
  }

  get thresholdTooltipStyle(): string {
    let pct = this.normalizedPercent;
    return sanitizeHtml(`left: ${pct}%; top: 50%; transform: translate(-${pct}%, -50%);`);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::AskATeammate::HitlOptions': typeof HitlOptions;
    'operator/fin/setup/sections/ask-a-teammate/hitl-options': typeof HitlOptions;
  }
}
